<template>
  <v-row
    class="mx-5"
    v-if="report !== 'Relatórios'"
  >
    <v-col
      cols="12"
      md="2"
    >
      <v-select
        label="Acervo"
        dense
        :items="tipoPublicacoes"
        :value="filter.idTipopublicacao"
        @input="onFilter({idTipopublicacao: $event})"
        hide-details
        item-text="tipoPublicacao"
        item-value="idTipopublicacao"
        outlined
        clearable
        rounded
      ></v-select>
    </v-col>
    <v-col
      cols="12"
      md="2"
    >
      <v-select
        :items="segmentos"
        :value="filter.idSegmento"
        dense
        hide-details
        outlined
        clearable
        label="Área"
        item-text="segmento"
        item-value="id"
        rounded
        @input="onFilter({idSegmento: $event})"
      ></v-select>
    </v-col>

    <v-col
      cols="12"
      md="2"
    >
     <v-autocomplete
        :items="palavraschave"
        v-model="filter.palavrachave"
        dense
        hide-details
        outlined
        clearable
        label="Palavras-chave *"
        item-text="palavrachave"
        item-value="palavrachave"
        placeholder="Digite para pesquisar"
        rounded
        @update:search-input="searchKeywords"
        @input="onFilter({palavrachave: $event})"
      ></v-autocomplete>
  </v-col>
    <v-col
      cols="12"
      md="6"
      class="text-right"
    >
      <v-btn
        color="accent"
        rounded
        @click="generate"
      >
        GERAR RELATÓRIO
      </v-btn>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: {
    onFilter: {
      type: Function,
      default: () => {},
    },
    searchKeywords: {
      type: Function,
      default: () => {},
    },
    generateReport: {
      type: Function,
      default: () => {},
    },
    report: {
      type: String,
      default: '',
    },
    tipoPublicacoes: {
      type: Array,
      default: () => [],
    },
    segmentos: {
      type: Array,
      default: () => [],
    },
    palavraschave: {
      type: Array,
      default: () => [],
    },
    filter: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      search: null,
      palavrachave: null,
    };
  },
  methods: {
    generate() {
      this.generateReport(this.report);
    },
  },
};
</script>
